// extracted by mini-css-extract-plugin
export var chevron = "_mw-3";
export var chevronRotated = "_mw-4";
export var image = "_mw-1";
export var imageContainer = "_mw-0";
export var shippingAddress = "_mw-2";